<template>
  <div class="task">
    <div class="task-header task-flex">
        <div class="text">
            <span class="title ellipsis">{{ title }}</span>
            <span>({{ totalFileSpeed }})</span>
        </div>
        <div class="btn">
            <el-button type="text" v-if="loading" @click="cancelTask">取消上传</el-button>
            <template v-else>
                <el-button type="text"  @click="nextUploadFileData">重试</el-button>
                <el-button type="text"  @click="()=>handleDelTaskData()">取消上传</el-button>
            </template>
        </div>
    </div>
    <el-progress 
        :text-inside="true" 
        :stroke-width="16" 
        :percentage="totalFileData" 
        :show-text="false"
        :status="loading? undefined :'exception'"
    />
     <div class="task-footer task-flex">
        <span v-if="!loading" style="color:red">
            上传失败
            <el-tooltip  effect="dark" placement="top">
                <div slot="content">
                     当前素材上传失败，失败原因:
                    <template v-if="stopUpload">
                       取消上传
                    </template>
                    <template v-else>
                        <p v-html="errorMsg" style="max-height: 400px; overflow: auto" />
                    </template>
                </div>
                <i class="el-icon-question"/>
            </el-tooltip>
        </span>
        <span v-else>{{ totalFileSize }}</span>
        <span>{{speed}}/S</span>
     </div>
  </div>
</template>

<script>
import COS from '@/libs/cos/WorkOrder'
import { formatFileSize } from '@/utils'
import { mapMutations } from 'vuex'
import API from '@/api/workOrder/upload.js'

export default {
    name:'TaskItem',
    props: [ 'taskData', 'type', 'UPLOAD_TYPE' ],
    data() {
        return {
            materialList: [],
            speed: '0B',
            taskId: [],//上传文件任务的id
            loading: false,
            errorMsg: '',
            maxNum: 0,
            uploadFileList: [],
            stopUpload: false,
            saveEnd: false,
            errorUploadFileList: [],
            percentageNum: 0,
            loopTime: null,
        }
    },
    computed: {
        fileList() {
            return this.taskData.file_list.map(v=>v.fileData || v)
        },
        totalFileSpeed() {
            return `${this.materialList.length - this.errorUploadFileList.length + this.percentageNum}/${this.fileList.length}`
        },
        totalFileData() {
            return Math.floor((this.materialList.length - this.errorUploadFileList.length + this.percentageNum)*100/this.fileList.length)
        },
        totalFileSize() {
            const size = this.fileList.reduce((pre,cur)=> {
                return pre + cur.size
            }, 0);
            return formatFileSize(size);
        },
        title() {
            if (this.UPLOAD_TYPE.MATERIAL === this.type) {
                const name = this.taskData.project_name;
                return name? name: '通用素材'
            }else {
                return this.taskData.order_name ||this.taskData.project_name;
            }
        }
    },
    mounted() {
        this.uploadFileList = [ ...this.taskData.file_list ];
        this.nextUploadFileData()
        this.loopLock()
    },
    methods: {
         ...mapMutations('workOrder', [
            'DEL_TASK_ITEM',
            'DEL_WORK_TASK_ITEM'
        ]),
        // 5分钟循环加锁
        loopLock() {
            if (this.UPLOAD_TYPE.MATERIAL === this.type ) {
                return;
            };
            this.loopTime = setTimeout(()=>{
                this.lockWorkOrder();
                this.loopLock();
            }, 5 *60 * 1000);
        },
        async nextUploadFileData() {
            try {
                await this.lockWorkOrder()
                this.stopUpload = false;
                this.percentageNum = this.errorUploadFileList.length;
                await Promise.all(Array.from({length: 10}).map(v=>this.uploadFileData()));
                this.saveData();
            } catch (error) {
                this.errorMsg = error.info ? error.info : error
                this.$message.error(error.info || error.message)
                this.loading = false
            }
        },
        async uploadFileData() {
            console.log('执行任务中....');
            // const max = 3;
            // fileList.reduce((pre, item)=> {
            //     const last = pre[pre.length - 1];
            //     if (last.length <3) {
            //         last.push(item)
            //     } else {
            //         pre.push([ item ])
            //     }
            //     return pre;
            // }, []);
            let item = null;
            try {
                this.loading = true;
                let taskId = null;
                while(this.loading&&!this.stopUpload&&(item = this.uploadFileList.shift())) {
                    const file =  item.fileData;
                    const result = await COS.putObject(file, {
                        onProgress:(progress)=>{
                            const { speed } = progress;
                            this.speed = formatFileSize(speed)
                        },
                        onTaskReady: (id)=> {
                            this.taskId.push(taskId = id);
                        }
                    });
                    this.taskId = this.taskId.filter(id=> id !==taskId);
                    const param = this.getFileParams(file, item, result);
                    this.materialList.push(param)
                    item = null;
                };
                if (this.stopUpload) {
                    this.loading = false
                    return;
                }
            } catch (error) {
                this.errorMsg = error.info ? error.info : error
                console.log(error, '工单上传');
                this.$message.error(`工单素材上传发生错误${error.message}`)
                this.loading = false
            }finally {
                item&&this.uploadFileList.unshift(item)
            }
        },
        getFileParams(file, item, result) {
            const basePath = COS.getBasePrefix();
            const location = result.Location;
            const path = location.split(basePath).pop();
            const param = {
                ...Object.keys(item).reduce((pre, key)=> {
                    if (item[key] instanceof File) {
                        return pre;
                    };
                    pre[key] = item[key];
                    return pre
                }, {}),
                material_url: path,
                material_name: file.name,
                label_ids: item.label_ids.toString(),
                md5: item.md5
            };
            return param;
           
        },
        // 取消任务上传
        cancelTask() {
            this.$confirm('取消上传会取消列表中所有的素材上传，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (this.saveEnd) {
                        this.$message.success("素材已上传成功，无法取消，请到处理中心查看")
                    }else {
                        this.stopUpload = true;
                        this.loading = false;
                        if (this.taskId.length) {
                            for (const id of this.taskId) {
                                COS.cancelTask(id)
                            };
                            this.taskId = []
                        }
                        this.delTaskData()
                    }
                }).catch(() => {});
        },
        async saveData() {
            try {
                if (this.UPLOAD_TYPE.MATERIAL === this.type) {
                    await this.uploadMaterialStorehouse()
                }else {
                    await this.saveWorkOrderData()
                };
                this.saveEnd = true;
            } catch (error) {}
        },
        async saveWorkOrderData() {
            try {
                this.loopTime&&clearTimeout(this.loopTime);
                await this.unLockWorkOrder();
                const { isBatch, producer_list, material_id } = this.taskData;
                if (material_id) {
                    const params = {
                        ...this.taskData,
                        ...(this.materialList[0] || {}),
                        file_list: undefined,
                    }
                    await API.reMaterialUpload(params)
                }else {
                    const material_list = this.getMaterialList()
                    const params = {
                        ...this.taskData,
                        material_list,
                        file_list: undefined,
                    }
                    //批量
                    if (isBatch) {
                        await API.batchMaterialUpload(params)  
                    // 单独
                    }else {
                        await API.singleMaterialUpload(params)
                    }
                }
               
                this.$message.success(`素材上传到处理中心成功，可以到右上角处理中心查看处理进度。`)
                this.delTaskData()
            } catch (error) {
                this.lockWorkOrder();
                this.loopLock()
                this.retryErrorInfo(error)
                this.loading = false
                console.log(error, '工单添加失败');
            }
        },
        // 素材库上传
        async uploadMaterialStorehouse() {
            try {
                const material_list = this.getMaterialList()
                const params = {
                    ...this.taskData,
                    material_list,
                    file_list: undefined
                };
                await API.uploadMaterialStorehouse(params);
                this.delTaskData()
                this.$message.success('素材上传到处理中心成功，可以到右上角处理中心查看处理进度。')
            } catch (error) {
                this.retryErrorInfo(error);
                console.log(error, '素材添加失败');
                this.loading = false
            }
        },
        handleDelTaskData() {
             this.$confirm('取消上传会取消列表中所有的素材上传，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delTaskData();
            }).catch(() => {});
        },
        delTaskData() {
            if (this.UPLOAD_TYPE.MATERIAL === this.type) {
                this.DEL_TASK_ITEM(this.taskData)
            }else {
                this.loopTime&&clearTimeout(this.loopTime);
                this.unLockWorkOrder();
                this.DEL_WORK_TASK_ITEM(this.taskData);
            }
        },
        getMaterialList() {
            const material_urls = this.errorUploadFileList.map(v=>v.material_url);
            const material_list = this.materialList.filter(item=> {
                if (this.errorUploadFileList.length) {
                    return material_urls.includes(item.material_url)
                }else {
                    return true;
                }
            });
            return material_list;
        },
        retryErrorInfo(error) {
            console.log(error, 'error.error_list');
            const error_list = error.data?.error_list || [];
            if (error_list.length) {
                const material_list = this.getMaterialList();
                // 有成功上传的
                if (material_list.length > error_list.length) {
                    this.$message.success('部分素材已上传到处理中心成功，可以到右上角处理中心查看处理进度。')
                }else {
                    this.$message.error(error.info)
                }
                const list = this.errorUploadFileList = error_list;
                this.errorMsg =list.map(v=>v.err_msg).join('<br/>');
                this.percentageNum = 0;
            }else {
                this.errorMsg = error.info ? error.info : error;
                this.$message.error(error.info)
            }
           
        },
        // 加锁
        async lockWorkOrder() {
            // 素材库上传不需要锁
            if (this.UPLOAD_TYPE.MATERIAL === this.type ) {
                return;
            }
            const params = {
                assign_id: this.taskData.assign_id
            }
            await API.lockWorkOrder(params)
        },
        // 解锁
        async unLockWorkOrder() {
            const params = {
                assign_id: this.taskData.assign_id
            }
            await API.unLockWorkOrder(params)
        }
    },
}
</script>

<style lang="scss" scoped>
.task {
    border: 1px solid #818181;
    border-radius: 6px;
    height: 100px;
    margin: 4px 0;
    background: #fff;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .text {
        display: flex;
        align-items: center;
    }
    .title {
        display: inline-block;
        max-width: 200px;
    }
    &-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #000;
    }
}
</style>